import { useMemo } from 'react'
import {
  ICourse,
  IEducation,
  IEmployer,
  ILanguageSkill,
  IPersonCertificate,
  IPersonCompetence,
  IPersonIndustry,
  IPersonRole,
  IPersonSkill,
  IProject,
  IReference,
} from 'types/cvsInterfaces'
import { IPerson } from 'types/userInterfaces'
import { buildEmptyProfileWarnings, buildProfileWarnings } from './checkers'

interface IUseProfileWarningsInput {
  personData?: IPerson
  skills: IPersonSkill[]
  industries: IPersonIndustry[]
  roles: IPersonRole[]
  employers: IEmployer[]
  projects: IProject[]
  education: IEducation[]
  courses: ICourse[]
  certificates: IPersonCertificate[]
  competences: IPersonCompetence[]
  references: IReference[]
  languageSkills: ILanguageSkill[]
  activeLanguageCode: string
  enabled?: boolean
}

const useProfileWarnings = ({
  personData,
  skills,
  industries,
  roles,
  employers,
  projects,
  education,
  courses,
  certificates,
  competences,
  references,
  languageSkills,
  activeLanguageCode,
  enabled = true,
}: IUseProfileWarningsInput) => {
  return useMemo(() => {
    if (!enabled) {
      return buildEmptyProfileWarnings()
    }

    return buildProfileWarnings({
      personData,
      skills,
      industries,
      roles,
      employers,
      projects,
      education,
      courses,
      certificates,
      competences,
      references,
      languageSkills,
      activeLanguageCode,
    })
  }, [
    activeLanguageCode,
    certificates,
    competences,
    courses,
    education,
    enabled,
    employers,
    industries,
    languageSkills,
    personData,
    projects,
    references,
    roles,
    skills,
  ])
}

export default useProfileWarnings
